// for purchase plan group leader to set plan to draft status for editing
export default function EditReleasedPlanService($log, $http, $q) {
  'ngInject';

  return function (requestId, purchasePlanId) {
    console.warn(
      'The editReleasedPlanService has been deprecated and will be removed from a future release.'
    );

    return $http.post(
      '/aptitude/buyer/PurchasePlanServiceController/editReleasedPlan',
      { requestId: requestId },
      { params: { purchasePlanId: purchasePlanId } }
    );
  };
}
